var app = angular.module("leonardo");

var ReportsPropertyAmenitiesList = function ($scope, $controller, $rootScope, $filter, ReportService, FilterService) {

  $controller('ReportsBaseController', { $scope: $scope });

  $scope.title = $filter('translate')('Property Attributes Reports');
  $scope.report_type = ReportService.TYPE_PROPERTY_AMENITIES;
  $scope.IdFields = ReportService.propertyIdFields;
  $scope.fieldsReport = ReportService.fieldsReportProperty;
  $scope.showDetailsTable = FilterService.filters.detailed != null ? FilterService.filters.detailed : false;

  // $scope.resetToggle = function () {
  //   $scope.showDetailsTable = false;
  // }
 
  // Listen for state change success
  $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
    if(toState.url !== '/property-amenities'){
      ReportService.setDetailsView(false);
    }
  });

  $scope.toggleValue = function (showDetailsTable) {
    $scope.showDetailsTable = showDetailsTable;
    ReportService.setDetailsView($scope.showDetailsTable);
    if(FilterService.getFilter('fields_active') != null){
      var filtersData = angular.copy(FilterService.filters.filters);
      // Check if filtersData is a string
      if (typeof filtersData === 'string') {
        // If it's a string, split it into an array
        filtersData = filtersData.split(',');
      }
      var filters = filtersData;
      var filter_id = 'fields_active';
      angular.forEach(filters, function (filter, key) {
        if (filter === filter_id) {
          filters.splice(key, 1);
          FilterService.removeFilter(filter_id);
        }
      });
      FilterService.setFilter('filters', !isNull(filters) ? filters.join(',') : filters);
    }
    ReportService.doFilter();
  }

  $scope.getValueAmenity = function (subgroup_field) {
    return (subgroup_field.value && (subgroup_field.value !== true)) ? subgroup_field.value : null;
  };

  $scope.groupReports = function(data) {
    if (data.results) {
      $scope.reports = data.results ? data.results : data;
      if (data.results.info_data) {
        $scope.info_data = data.results.info_data;
      }
    }
    else {
      $scope.reports = data;
    }

    $scope.reportsGrouped = [];
    var id = 'ungroup';
    var name = 'Ungroup';
    var array_by_name = [];
    switch (FilterService.getFilter('group_by')) {
      case 'account':
        angular.forEach($scope.accounts_by_name, function (account) {
          if (getIndexArray(array_by_name, account.id) < 0) {
            array_by_name.push({ id: account.id, name: account.name });
          }
        });
        break;
      case 'portfolio':
        angular.forEach($scope.portfolios_by_name, function (portfolio) {
          if (getIndexArray(array_by_name, portfolio.id) < 0) {
            array_by_name.push({ id: portfolio.id, name: portfolio.name });
          }
        });
        break;
      case 'property':
        angular.forEach($scope.properties_by_name, function (property) {
          if (getIndexArray(array_by_name, property.id) < 0) {
            array_by_name.push({ id: property.id, name: property.name });
          }
        });
        break;
    }
    angular.forEach($scope.reports, function (value) {
      switch (FilterService.getFilter('group_by')) {
        case 'account':
          if (value.account) {
            id = value.account.id;
            name = value.account.name;
          }
          else {
            id = 'no_account';
            name = 'No account';
            array_by_name.push({ id: id, name: name });
          }
          break;
        case 'portfolio':
          if (value.portfolio) {
            id = value.portfolio.id;
            name = value.portfolio.name;
          }
          else {
            id = 'no_portfolio';
            name = 'No portfolio';
            array_by_name.push({ id: id, name: name });
          }
          break;
        case 'property':
          if (value.id) {
            id = value.id;
            name = value.name;
          }
          else {
            id = 'no_property';
            name = 'No property';
            array_by_name.push({ id: id, name: name });
          }
          break;
        case 'group':
          if (value.groups) {
            id = [];
            name = [];
            array_by_name = [];
            angular.forEach(value.groups, function (group) {
              if (FilterService.hasFilter('group_reports')) {
                if (_.contains(FilterService.getFilter('group_reports').toString().split(','), group.id.toString())) {
                  id.push(group.id);
                  name.push(group.name);
                  array_by_name.push({ id: group.id, name: group.name });
                }
              } else {
                id.push(group.id);
                name.push(group.name);
                array_by_name.push({ id: group.id, name: group.name });
              }
            });
          }
          else {
            id = 'no_group';
            name = 'No group';
            array_by_name.push({ id: id, name: name });
          }
          break;
        case 'managed_by':
          if (value.managed_by) {
            if (angular.isArray(value.managed_by)) {
              id = [];
              name = [];
              array_by_name = [];
              angular.forEach(value.managed_by, function (manager) {
                id.push(manager.id);
                name.push(manager.name);
                array_by_name.push({ id: manager.id, name: manager.name });
              });
            }
            else {
              id = value.managed_by.id;
              name = value.managed_by.name;
              array_by_name.push({ id: value.managed_by.id, name: value.managed_by.name });
            }
          }
          else {
            id = 'only_owner';
            name = 'Only Owner';
            array_by_name.push({ id: id, name: name });
          }
          break;
        case 'user_role':
          if (value.account_user) {
            id = value.account_user.role;
            name = value.account_user.role;
            array_by_name = [{ id: id, name: name }];
          }
          else {
            id = 'no_group';
            name = 'No group';
            array_by_name.push({ id: id, name: name });
          }
          break;
      }
      if (angular.isArray(id)) {
        angular.forEach(array_by_name, function (value_manager) {
          if ($scope.getIndex(value_manager.id) < 0) {
            $scope.reportsGrouped.push({ id: value_manager.id, name: value_manager.name, reports: [] });
          }
          if (getIndexArray($scope.reportsGrouped[$scope.getIndex(value_manager.id)].reports, value.id) === -1) {
            $scope.reportsGrouped[$scope.getIndex(value_manager.id)].reports.push(value);
          }
        });
      }
      else {
        if ($scope.getIndex(id) < 0) {
          $scope.reportsGrouped.push({ id: id, name: name, reports: [] });
        }
        if (getIndexArray($scope.reportsGrouped[$scope.getIndex(id)].reports, value.id) === -1) {
          $scope.reportsGrouped[$scope.getIndex(id)].reports.push(value);
        }
      }
    });

    if ($scope.reportsGrouped.length === 1) {
      $scope.groupExpanded = $scope.reportsGrouped[0].id;
    }
    else {
      $scope.reportsGrouped = $filter('orderBy')($scope.reportsGrouped, 'name');
    }


    $scope.fieldsAmenities = [];
    $scope.subAmenities = [];
    $scope.fieldsToShow = [];
    $scope.subFieldsToShow = [];
    var subAmenities = [];
    var amenities = [];
    $scope.extra_fields = FilterService.hasFilter('extra_fields') ? FilterService.getFilter('extra_fields').split(',') : [];

    var fields = FilterService.hasFilter('fields_active') ? FilterService.getFilter('fields_active').split(',') : [];
    var subAmenities = [];
    var amenities = [];


    angular.forEach($scope.reportsGrouped, function (group) {
      var newData = [];
      angular.forEach(group.reports, function (report, reportIndex) {
        if($scope.showDetailsTable){
          $scope.matchingValues = [];
          if(fields && fields.length > 0 && $scope.matchingValues && $scope.matchingValues.length === 0 ){
            //find matchingValues for property header 
            $scope.matchingValues = report.property_fields.filter(function (propertyField) {
              return fields.includes(propertyField.key);
          });
          }
        }
        newData.push({
          portfolio: report.portfolio,
          property: report.name,
          property_id: report.id,
          groups: report.groups,
          pms_external_id: report.pms_external_id,
          fields: {},
          subFields: {},
          propertyFields:report.property_fields,
          subpropertyFields:{}
        });

        if ($scope.showDetailsTable) {
          if (report.property_fields) {
            angular.forEach(report.property_fields, function (propertyField) {
              let reportArray = [];
              reportArray.push({ name: propertyField.name, value: propertyField.value, key: propertyField.key });
              newData[reportIndex].subpropertyFields[propertyField.name] = reportArray
            });
          }
        }


        if (report.field_groups[0].name === "Property Amenities" && !$scope.showDetailsTable) {
          var temp = report.field_groups[0];
          report.field_groups[0] = report.field_groups[1];
          report.field_groups[1] = temp;
        }

        angular.forEach(report.field_groups, function (field_group) {
          var length = 0;
          var subGroupFieldLength = 0;
          angular.forEach(field_group.subgroups, function (subgroup) {
            var fieldToShowSubGroup = 0;
            var array = [];
            if (subgroup && subgroup.subgroup_fields && subgroup.subgroup_fields.length > 0) {
              angular.forEach(subgroup.subgroup_fields, function (subgroup_field) {
                if (!subgroup_field.data || !subgroup_field.data.select_all) {
                  array.push({ name: subgroup_field.name, value: $scope.getValueAmenity(subgroup_field) });
                }
                if ($scope.showDetailsTable) {
                  let array1 = [];
                  if (!subgroup_field.data || !subgroup_field.data.select_all) {
                    array1.push({ name: subgroup_field.name, value: subgroup_field.value, fieldName: subgroup.name });
                  }

                  newData[reportIndex].subFields[subgroup_field.name] = array1

                  subAmenities.push({
                    id: subgroup_field.id,
                    name: subgroup_field.name,
                    key: subgroup_field.key,
                    value: subgroup_field.value,
                    fieldName: subgroup.name,
                  });

                  if ((fields.length === 0) || (_.contains(fields, subgroup_field.key))) {
                    subGroupFieldLength++;
                  }
                  if ((fields.length === 0) || (_.contains(fields, subgroup_field.key))) {
                    fieldToShowSubGroup++;
                  }
                }

              });
            } 
            subgroup.fieldToShowSubGroup =fieldToShowSubGroup;
            newData[reportIndex].fields[subgroup.name] = array;

            amenities.push(subgroup);
            
            if ((fields.length === 0) || (_.contains(fields, subgroup.key))) {
              length++;
            }
          });
          
          field_group.length = length > 0 ? length : subGroupFieldLength;
          if ($scope.showDetailsTable) {
            field_group.subGroupFieldLength = subGroupFieldLength || 0;
          }
        });
      });
      $scope.fieldsAmenities = amenities;
      $scope.subAmenities = $scope.showDetailsTable ? subAmenities : [];
      group.newData = newData;
    });

    // get unique records
    $scope.fieldsAmenities = $scope.uniqueFieldToShow(amenities);
    $scope.subAmenities = $scope.uniqueSubFieldToShow(subAmenities);

    if(fields.length === 0){
      angular.forEach($scope.fieldsAmenities, function (subgroup) {
        if (!_.contains($scope.fieldsToShow, subgroup.name)) {
          $scope.fieldsToShow.push(subgroup);
        }
      });
      if($scope.showDetailsTable){
        angular.forEach($scope.subAmenities, function (subgroup) {
          if (!_.contains($scope.subFieldsToShow, subgroup.name) || !_.contains($scope.subFieldsToShow, subgroup.fieldName)) {
            $scope.subFieldsToShow.push(subgroup);
          }
        });
      }
    }
    else {
      if(!$scope.showDetailsTable){
        angular.forEach(fields, function (field) {
          angular.forEach($scope.fieldsAmenities, function (subgroup) {
            if ((field === subgroup.key) && !_.contains($scope.fieldsToShow, subgroup.name)) {
              $scope.fieldsToShow.push(subgroup);
            }
          });
        });

        // Arrange fieldsToShow based on the order of subgroups in field_groups
        $scope.arrangeFieldsToShow();
      }

      if($scope.showDetailsTable){
        angular.forEach(fields, function (subField) {
          $scope.fieldsAmenities.map(function (subgroup) {
            subgroup.subgroup_fields.forEach(function (subGroupField) {
              if (subField === subGroupField.key && !$scope.fieldsToShow.some(function (item) { return item.name === subgroup.name })) {
                $scope.fieldsToShow.push(subgroup);
              }
            });
          });
        
          $scope.subAmenities.map(function (subgroup) {
            
            if ((subField === subgroup.key) && (!$scope.subFieldsToShow.some(function (item) { return item.name === subgroup.name || item.name === subgroup.fieldName }))) {
              $scope.subFieldsToShow.push(subgroup);
            }
          });
        });
      
        $scope.fieldsToShow = $scope.uniqueFieldToShow($scope.fieldsToShow);
        $scope.sortSubFieldToShow();
      }
    }
  };

  // Sort subFieldToshow according to fieldToshow.name
  $scope.sortSubFieldToShow = function(){
    $scope.subFieldsToShow.sort(function(a, b) {
      var fieldNameA = a.fieldName;
      var fieldNameB = b.fieldName;

      for (var i = 0; i < $scope.fieldsToShow.length; i++) {
          if ($scope.fieldsToShow[i].name === fieldNameA) {
              fieldNameA = i; // Use the index as the sorting key
          }
          if ($scope.fieldsToShow[i].name === fieldNameB) {
              fieldNameB = i; // Use the index as the sorting key
          }
      }

      return fieldNameA - fieldNameB;
    });
  }
  

  $scope.uniqueFieldToShow = function(amenities){
    var uniqueAmenities = [];
    // Create a Set to store unique records
    const uniqueFieldAmenities = new Set();
    // Filter the subAmenities array to get unique records based on 'id'
    uniqueAmenities = amenities.filter((amenity) => {
      const isUnique = !uniqueFieldAmenities.has(amenity.id);
      if (isUnique) {
        uniqueFieldAmenities.add(amenity.id);
      }
      return isUnique;
      });

      return uniqueAmenities;
  }

  $scope.uniqueSubFieldToShow =function(subAmenities){
    var uniqueSubAmenities = [];
    var seenCombinations = {};

    for (var i = 0; i < subAmenities.length; i++) {
      var subAmenity = subAmenities[i];
      var key = subAmenity.key + "-" + subAmenity.fieldName;
      if (!seenCombinations[key]) {
        uniqueSubAmenities.push(subAmenity);
        seenCombinations[key] = true;
      }
    }
    return uniqueSubAmenities;

  }

  $scope.showGroups = function () {
    var fields = FilterService.hasFilter('fields_active') ? FilterService.getFilter('fields_active').split(',') : [];
    return _.contains(fields, 'groups');
  };

  $scope.showPMS = function () {
    var fields = FilterService.hasFilter('fields_active') ? FilterService.getFilter('fields_active').split(',') : [];
    return _.contains(fields, 'pms_external_id');
  };

  // Arrange fieldsToShow based on the order of subgroups in field_groups
  $scope.arrangeFieldsToShow = function() {
    if ($scope.reportsGrouped.length > 0 && $scope.reportsGrouped[0].reports.length > 0) {
      const fieldGroups = $scope.reportsGrouped[0].reports[0].field_groups;
      const arrangedFieldsToShow = [];

      angular.forEach(fieldGroups, function (field_group) {
        angular.forEach(field_group.subgroups, function (subgroup) {
          const field = $scope.fieldsToShow.find(f => f.key === subgroup.key);
          if (field) {
            arrangedFieldsToShow.push(field);
          }
        });
      });

      $scope.fieldsToShow = arrangedFieldsToShow;
    }
  }

};

app.controller('ReportsPropertyAmenitiesList', ['$scope', '$controller', '$rootScope', '$filter', 'ReportService',
  'FilterService', ReportsPropertyAmenitiesList]);
